
(()=>{
 const deadline=Date.parse('2026-11-08T00:00:00+01:00');
 function expire(){
  document.querySelectorAll('[data-tz-sale-banner],.tz-sale-note').forEach(el=>{el.hidden=true;});
  document.querySelectorAll('[data-tz-sale-price]').forEach(el=>{const text=el.dataset.regular;el.replaceWith(document.createTextNode(text||''));});
 }
 function tick(){
  const left=Math.max(0,Math.floor((deadline-Date.now())/1000));
  if(!left){expire();return;}
  const values=[Math.floor(left/86400),Math.floor(left%86400/3600),Math.floor(left%3600/60),left%60];
  document.querySelectorAll('[data-tz-sale-banner]').forEach(b=>{['days','hours','minutes','seconds'].forEach((k,i)=>{const n=b.querySelector('[data-tz-'+k+']');if(n)n.textContent=String(values[i]).padStart(2,'0');});});
 }
 function init(){
  if(!document.querySelector('[data-tz-sale-banner]')){
   const t=document.getElementById('tz-sale-fallback');const header=document.querySelector('.tz-topbar,header-component');
   if(t&&header&&Date.now()<deadline)header.after(t.content.cloneNode(true));
  }
  tick();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 const timer=setInterval(()=>{tick();if(Date.now()>=deadline)clearInterval(timer);},1000);
 document.addEventListener('shopify:section:load',init);
 document.addEventListener('visibilitychange',()=>{if(!document.hidden)tick();});
 new MutationObserver(()=>{if(Date.now()>=deadline)expire();}).observe(document.documentElement,{childList:true,subtree:true});
})();
